import React from 'react';
import { Box, Flex, Heading, Text, useColorModeValue } from '@chakra-ui/react';
import { FaMapMarkerAlt } from 'react-icons/fa';

import { SelectAddressProps } from './select-address-helpers';

export type AutocompletePrediction = google.maps.places.AutocompletePrediction;
export type PredictionsListProps = Pick<SelectAddressProps, 'predictionContainerProps' | 'testId'> & {
  placePredictions: AutocompletePrediction[];
  handleSelectLocation: (location: AutocompletePrediction) => Promise<void>;
};

export function PredictionsList({
  placePredictions,
  handleSelectLocation,
  predictionContainerProps,
  testId,
}: PredictionsListProps) {
  const predictionHoverColor = useColorModeValue('gray.50', 'gray.700');

  if (!placePredictions.length) return null;

  return (
    <Box
      width={{ base: '100%', lg: '50%' }}
      mt={2}
      py={3}
      data-testid={`${testId}-prediction-list`}
      {...predictionContainerProps}
    >
      <Heading mb={1} size={'md'}>
        Results
      </Heading>
      {placePredictions.map((location, i) => (
        <Box
          data-testid={`${testId}-prediction-${i}`}
          className={`${testId}-prediction-item`}
          borderBottom={i === placePredictions.length - 1 ? '1px solid grey' : undefined}
          borderTop={'1px solid grey'}
          key={`google-maps-location-${i}`}
          _hover={{ background: predictionHoverColor }}
          onClick={async () => handleSelectLocation(location)}
          cursor={'pointer'}
          py={2}
        >
          <Flex align={'center'} as={'button'} type={'button'}>
            <Box mr={1}>
              <FaMapMarkerAlt />
            </Box>
            <Text fontWeight={600} fontSize={'sm'}>
              {location.description}
            </Text>
          </Flex>
        </Box>
      ))}
      <Text mt={2} fontSize={'xs'}>
        Powered by Google
      </Text>
    </Box>
  );
}
